import logo from './logo.svg';
import './App.css';
import HomePage from './pages/Home';
import AppRoutes from './routes';

function App() {
  return (
    <AppRoutes/>
  );
}

export default App;
